import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=a8610120&"
import script from "./invoice.vue?vue&type=script&lang=js&"
export * from "./invoice.vue?vue&type=script&lang=js&"
import style0 from "./invoice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports